import { useEffect } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import verificationSuccessImage from '../../../assets/email-success.svg';
import Button from '../../../components/buttons/Button';
import { DialogContent } from '../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogHeader';
import type { WizardChildProps } from '../../../components/Wizard/types';
import { analytics } from '../../../services/analytics';
import { useStores } from '../../../stores/useStores';

import styles from './VerificationSuccess.module.scss';

export const VerificationSuccess = observer((props: WizardChildProps) => {
  const { authStore } = useStores();
  const { t } = useTranslation();

  const landingKey = authStore.getLandingKey();

  useEffect(() => {
    if (props.isCurrent) {
      void analytics.sendEvent('sign_up', {
        step_name: 'verify_email_account',
        event_action: 'impression',
        sign_up_platform: 'email',
        landingKey,
      });
    }
  }, [props.isCurrent, landingKey]);

  return (
    <>
      <DialogHeader title={t('dialogs.successLowerCase')} onClose={props.nextStep} />

      <DialogContent>
        <p>{t('auth.emailVerifiedSuccessfully')}</p>
        <img alt="envelope" className={styles.envelope} src={verificationSuccessImage} />

        <Button btnType="main" onClick={props.nextStep}>
          {t('common.closeLowerCase')}
        </Button>
      </DialogContent>
    </>
  );
});
